import {
    FACEBOOK_ADS_METRICS,
    GA_METRICS,
    GOOGLE_ADS_METRICS,
    METRICS_TYPES,
    PIPEDRIVE_METRICS,
    LOJA_INTEGRADA_METRICS,
    SHOPIFY_METRICS,
    WOOCOMMERCE_METRICS,
    PARETO_ADS_METRICS,
} from './MetricsTypeConstants';

const SEGMENTED_SELECTOR_METRICS = {
    reportIntegration: {
        ...PIPEDRIVE_METRICS,
        ...LOJA_INTEGRADA_METRICS,
        ...SHOPIFY_METRICS,
        ...WOOCOMMERCE_METRICS,
    },
    gaMetrics: GA_METRICS,
    paretoAdsMetrics: PARETO_ADS_METRICS,
    accountMetrics: {
        google_ads: GOOGLE_ADS_METRICS,
        facebook_ads: FACEBOOK_ADS_METRICS,
    },
};

const GRAPHIC_PARAMS = {
    FIRST_METRIC: 'firstMetric',
    SECOND_METRIC: 'secondMetric',
};

const PERIOD_COMPARISON_DATE = {
    data: 'data',
    comparisonData: 'comparisonData',
};

export const PERIODS = {
    PREVIOUS_PERIOD: 'previous_period',
    SAME_PERIOD_LAST_YEAR: 'same_period_last_year',
};

const PERIOD_OPTIONS = [{
    label: gettext('Previous period'),
    value: PERIODS.PREVIOUS_PERIOD,
    type: METRICS_TYPES.comparison,
}, {
    label: gettext('Same Period Last Year'),
    value: PERIODS.SAME_PERIOD_LAST_YEAR,
    type: METRICS_TYPES.comparison,
}];

const PERIOD_FIELDS = {
    comparison_period: {
        type: METRICS_TYPES.comparison,
    },
    previous_period: {
        label: gettext('Previous period'),
        value: PERIODS.PREVIOUS_PERIOD,
        type: METRICS_TYPES.comparison,
    },
    same_period_last_year: {
        label: gettext('Same Period Last Year'),
        value: PERIODS.SAME_PERIOD_LAST_YEAR,
        type: METRICS_TYPES.comparison,
    },
};

const SEGMENTED_WIDGET_SUBTITLE = {
    google_ads: gettext('From Google Ads'),
    facebook_ads: gettext('From Facebook Ads'),
};

export {
    GRAPHIC_PARAMS,
    PERIOD_OPTIONS,
    PERIOD_FIELDS,
    PERIOD_COMPARISON_DATE,
    SEGMENTED_WIDGET_SUBTITLE,
    SEGMENTED_SELECTOR_METRICS,
};
